import React from 'react';

export const ChartPaginationContext = React.createContext(null);

export function useChartPaginationContext() {
  const context = React.useContext(ChartPaginationContext);
  if (!context) {
    throw new Error(
      'ChartPagination compound components must be used within ChartPagination.Root',
    );
  }
  return context;
}
